import angular from 'angular';
import ingredientFormComponent from './ingredient-form.component';

export default angular.module('components.app.product.ingredientForm', [])
  .component('productIngredientForm', ingredientFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/ingredient-form/ingredient-form.module.js